import { graphql } from "react-relay";

export const LEARN_OPPORTUNITY_V2_FRAGMENT = graphql`
	fragment resetLearnProgressButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {
		id
		structureDefinition {
			title
		}
	}
`;

export const RESET_LEARN_PROGRESS_MUTATION = graphql`
	mutation resetLearnProgressButton_ResetLearnProgressMutation($input: ResetLearnProgressInput!) {
		Admin {
			LearnProgress {
				resetLearnProgress(input: $input) {
					clientMutationId
				}
			}
		}
	}
`;
